<template>
  <div :class="['container wide-banner', _isMobile() ? 'mobile' : '']">
    <Header />
    <div class="banner-wrap">
      <Banner/>
    </div>
    <div class="home">
      <router-view />
    </div>
    <a-back-top />
    <Footer />
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { mixinDevice } from "@/utils/mixin.js";
import Header from "../components/Header";
import Banner from "../components/Banner";

import Footer from "../components/Footer";
export default {
  name: "HomeLayout",
  mixins: [mixinDevice],
  components: {
    Header,
    Banner,
    Footer,
  },
  data() {
    return {
      bgUrl: "/assets/background.svg",
    };
  },
  created() {
    const tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if (tenantConfig.homeBackground) {
      this.bgUrl = tenantConfig.themeConfig.homeBackground;
    }
  },
};
</script>
<style>
  a *{
    transition: all 0.1s ease;
  }
</style>
<style lang="less" scoped>
// 宽banner主题
.wide-banner{
  .banner {
    width: 100%!important;
    max-width: 100%!important;
  }
  .header{
    z-index: 99;
    position: absolute;
    background: #617ccba8;
    width: 100%;
  }
}
.container {
  .banner-wrap {
    .banner-bg{
      position: absolute;
      width: 100%;
    }
    .banner {
      margin: auto;
      max-width: 1200px;
      overflow: hidden;
      border-radius: 0 0 10px 10px;
    }
  }
  .home {
    max-width: 1200px;
    margin: 20px auto;
    padding: 20px 10px;
    background: #ffffff4a;
    border-radius: 30px;
  }
  /deep/.ant-list-pagination {
    text-align: center;
  }
  background: url(../assets/bg2.jpg);
}
</style>